import { EmailOutlined } from "@mui/icons-material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
	Button,
	Card,
	CardContent,
	Grid,
	Icon,
	IconButton,
	InputAdornment,
	LinearProgress,
	MenuItem,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme
} from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import "moment-timezone";
import "moment/locale/pt-br";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { useAuthContext } from "../../../context";
import { useProfile } from "../../../context/ProfileContext";
import { BasicModal, ModalContext, ToastContent, ToolbarAnalysis } from "../../../shared/components";
import { LoadingComp } from "../../../shared/components/loading/Loading";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";
import { IVFormErros, useVForm, VForm, VTextField } from "../../../shared/forms";
import { VMaskTextField } from "../../../shared/forms/VMaskTextField";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { useToast } from "../../../shared/hooks";
import { LayoutBaseDePagina } from "../../../shared/layouts";
import {
	analysisService,
	BiometryDetails,
	ICancelAnalysis,
	IDetalheAnalises,
	IGenerateTaxSetup,
	IRulesMaxProposal,
	ISendBiometria,
	ISendEmail,
	IUpdateAnalysisSuperAdmin,
} from "../../../shared/services/api/analysis/analysisService";
import { FinancialService } from "../../../shared/services/api/financial/FinancialService";
import { PeopleService } from "../../../shared/services/api/people/PeopleService";
import { IDetalheUsuario, userService } from "../../../shared/services/api/user/userService";
import { IMessage } from "../../../shared/types/message";
import { maskPhone } from "../../../shared/utils";
import { formatScaleValue } from "../../../shared/utils/formatScaleValue";
import { returnMessageError } from "../../../shared/utils/returnMessageError";
import { cancelReasons } from "../../proposal/components/ProposalDetail/helpers/reasonCancel";
// import { useFireInsuranceQuotation } from "../hooks/useFireInsuranceQuotation";
import { AnalysisCardData } from "./AnalysisCardData";
import { AnalysisEditModal } from "./AnalysisEditModal";
import ModalDetailSerasaResponse from "./ModalDetailSerasaResponse";
import { ModalDetailBiometrics } from "./Modals/ModaDetailBiometrics";
import { ModalResendBiometryLink } from "./Modals/ModalResendBiometryLink";
import { ModalSetupFee } from "./Modals/ModalSetupFee";
import { ModalApprovedV2 } from "./Modals/ModalApprovedV2";
import { ModalLogSerasaAnalysis } from "./Modals/ModalLogSerasaAnalysis";
import { ModalLogsAnalysis } from "./Modals/ModalLogsAnalysis";
import { RevertModal } from "./RevertModal";
import { SerasaResponseRejectedModalContent } from "./serasa-response-rejected/serasa-response-rejected-modal-content";
import { ModalConvertAnalysisToPj } from "./Modals/ModalConvertAnalysisToPj";

interface IPlan {
	id: string;
	lmi: string;
	status: string;
	clientId: string;
	planId: string;
	productId: string;
	residentialFee: string;
	commercialFee: string;
	flagAnalysis: string;
	flagRenovation: string;
	coverage: string;
	setup_transfer: string;
	proposalMin: string;
	plan: any[];
}

const removeMask = (value: string | number) => {
	return String(value)
		.replace(/\D/g, "")
		.replace(/[^0-9]/g, "")
		.replace(/(\d{1,2})$/, ".$1");
};

const formValidationSchema: yup.SchemaOf<ISendEmail> = yup.object().shape({
	email: yup.string().required("Campo Obrigatório"),
	id: yup.string().notRequired(),
	phone: yup.string().notRequired(),
});

const formEditValidationSchema: yup.SchemaOf<any> = yup.object().shape({
	id: yup.string().required("Campo Obrigatório"),
	status: yup.string().required("Campo Obrigatório"),
	obs: yup.string().default(""),
	createdFrom: yup.string().required("Campo Obrigatório"),
	assuranceMonthAmount: yup.string().default(""),
	rentAmount: yup.string().required("Campo Obrigatório"),
	lmi: yup.string().default(""),
	residentialFee: yup.string().default(""),
	commercialFee: yup.string().default(""),
	fee: yup.string().default(""),
	planlist: yup.string().required("Campo Obrigatório"),
	updatedAt: yup.date(),
});

const maskReal = (value: string) => {
	return value
		.replace(/\D/g, "")
		.replace(/(\d{1,2})$/, ",$1")
		.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

const validationSchema = yup.object().shape({
	responsavel: yup.string().required("Campo obrigatório"),
});

export const AnalysisDetailPresentation: React.FC = () => {
	const { id = "novo" } = useParams<"id">();
	const navigate = useNavigate();
	const { formRef } = useVForm();
	const { formRef: formRefEdit } = useVForm();
	const [isLoading, setIsLoading] = useState(false);
	const [nome, setNome] = useState("");
	const [doc, setDoc] = useState("");
	const [docLessor, setDocLessor] = useState("");
	const [status, setStatus] = useState("");
	const [openModal, setOpenModal] = useState(false);
	const [rows, setRows] = useState<IDetalheAnalises>();
	const [biometryRows, setBiometryRows] = useState<BiometryDetails>();
	const [plan, setPlan] = useState<IPlan[]>([]);
	const [user, setUser] = useState<IDetalheUsuario>();
	const [rentAmount, setRentAmount] = useState<number>(0);
	const [assuranceBaseCalc, setAssuranceBaseCalc] = useState<number>(0);
	const [chargesBaseCalc, setChargesBaseCalc] = useState<number>(0);
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));
	const [openModalResultAnalysis, setOpenModalResultAnalysis] = useState(false);
	const [openModalCancel, setOpenModalCancel] = useState(false);
	const [openModalGenerateProposal, setOpenModalGenerateProposal] = useState(false);
	const [reasonCancel, setReasonCancel] = useState("");
	const [propFinally, setProFinally] = useState("");
	const [reSendEmail, setReSendEmail] = useState(false);
	const [email, setEmail] = useState("");
	const [prevEmail, setPrevEmail] = useState("");
	const [prevPhone, setPrevPhone] = useState("");
	const [modalReAnalysis, SetModalReAnalisys] = useState(false);
	const [openModalSerasaResponse, setOpenModalSerasaResponse] = useState(false);
	const [openModalLogs, setOpenModalLogs] = useState(false);
	const { loggedUser } = useAuthContext();
	const { permissionLevel, isSuperAdmin, permissions, isPermissionInitialized } = useProfile();
	const [openModalEditSuper, setOpenModalEditSuper] = useState(false);
	const [isLoadingEditSuper, setIsLoadingEditSuper] = useState(false);
	const toastHandler = useToast();
	const canViewLogSerasa =
		isPermissionInitialized && (isSuperAdmin || !!permissions?.[PermissionRolesEnum.AnalysisOptions]?.[PermissionActionsEnum.LogSerasa]);
	const canViewLogAnalysis =
		isPermissionInitialized && (isSuperAdmin || !!permissions?.[PermissionRolesEnum.AnalysisOptions]?.[PermissionActionsEnum.LogAnalysis]);
	const canViewCreditDetails =
		isPermissionInitialized && (isSuperAdmin || !!permissions?.[PermissionRolesEnum.AnalysisOptions]?.[PermissionActionsEnum.CreditDetails]);
	const canViewBiometry =
		isPermissionInitialized && (isSuperAdmin || !!permissions?.[PermissionRolesEnum.AnalysisOptions]?.[PermissionActionsEnum.ViewBiometry]);
	const canResendAnalysis =
		isPermissionInitialized && (isSuperAdmin || !!permissions?.[PermissionRolesEnum.AnalysisOptions]?.[PermissionActionsEnum.ResendAnalysis]);
	const canResendAnalysisEmail =
		(isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.Conclude)) &&
		(status === "awaiting_signature" || status === "in_hiring");
	const [openModalLogsSerasa, setOpenModalLogsSerasa] = useState(false);
	const [createdFrom, setCreatedFrom] = useState<any>(null);
	const canShowLogsSection =
		!isLoading && !isLoadingEditSuper && !!rows && isPermissionInitialized && (canViewLogAnalysis || canViewLogSerasa);
	const [rulesMaxProposal, setRulesMaxProposal] = useState<IRulesMaxProposal>({
		rules: false,
		message: "",
	});
	const [openModalUpdateContact, setOpenModalUpdateContact] = useState(false);
	const [isLoadingSetupFee, setIsLoadingSetupFee] = useState(false);
	const [openModalSetupFee, setOpenModalSetupFee] = useState(false);
	const [openModalConvertToPj, setOpenModalConvertToPj] = useState(false);
	const [isLoadingConvertToPj, setIsLoadingConvertToPj] = useState(false);
	const [convertToPjFrom, setConvertToPjFrom] = useState<{ name: string; document: string }>({ name: "", document: "" });

	const canGenerateSetupFee = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.SetupFee);
	const canConvertAnalysisToPj =
		isPermissionInitialized &&
		(isSuperAdmin || !!permissions?.[PermissionRolesEnum.AnalysisOptions]?.[PermissionActionsEnum.ConvertAnalysisToPj]);
	const isTypePersonPhysical = String((rows as any)?.typePerson ?? "").toLowerCase() === "physical";
	const showConvertToPjAction = Boolean(canConvertAnalysisToPj && isTypePersonPhysical);
	const isAnalysisStatusOkForSetupFee = status === "issued" || status === "awaiting_biometria";
	const isSetupFeeEnabledForClient = Number(rows?.client?.tax_setup_enable ?? 0) === 1;
	const hasSetupFeeLink = Boolean(rows?.transaction?.id || rows?.installmentSetup?.id);
	// Para gerar a taxa de setup, o detalhe precisa indicar que ainda NÃO existe taxa gerada.
	// No payload atual isso é representado por transaction e installmentSetup como null/undefined.
	const isSetupFeeNotGeneratedYet = rows?.transaction == null && rows?.installmentSetup == null;
	const setupFeeLimitMin = parseFloat(String(rows?.client?.tax_setup_limit_min ?? "0"));
	const setupFeeLimitMax = parseFloat(String(rows?.client?.tax_setup_limit_max ?? "0"));
	const isSetupFeeConfigValid =
		isSetupFeeEnabledForClient &&
		Number.isFinite(setupFeeLimitMin) &&
		Number.isFinite(setupFeeLimitMax) &&
		setupFeeLimitMin >= 0 &&
		setupFeeLimitMax >= setupFeeLimitMin;
	const showGenerateSetupFeeAction =
		canGenerateSetupFee &&
		isAnalysisStatusOkForSetupFee &&
		isSetupFeeConfigValid &&
		isSetupFeeNotGeneratedYet &&
		!hasSetupFeeLink;

	const parsedPlans = React.useMemo(() => {
		try {
			if (!rows?.planlist) return [];
			return typeof rows.planlist === "string" ? JSON.parse(rows.planlist) : rows.planlist;
		} catch (e) {
			console.error("Error parsing planlist", e);
			return [];
		}
	}, [rows?.planlist]);
	const [openModalDetailSerasaResponse, setOpenModalDetailSerasaResponse] = useState(false);
	const [openModalRevert, setOpenModalRevert] = useState(false);
	const [showButtonRevert, setShowButtonRevert] = useState(false);
	const [showBiometry, setShowBiometry] = useState(false);
	const [isBlacklist, setIsBlacklist] = useState(0);
	const [openModalApprovedV2, setOpenModalApprovedV2] = useState(false);

	const handleOpenModalLogsSerasa = () => {
		if (!canViewLogSerasa) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Permissão negada" content="Você não possui permissão para visualizar o log do Serasa." />,
			});
			return;
		}
		setOpenModalLogsSerasa(true);
	};

	const handleCloseModalLogsSerasa = () => {
		setOpenModalLogsSerasa(false);
	};

	const handleOpenModalResultAnalysis = () => {
		if (rulesMaxProposal.rules) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: (
					<ToastContent
						title="Alerta!!!"
						subtitle="Análise com impedimento "
						content="Cliente atingiu quantidade máxima de garantias ativas. Entre em contato com suporte Garantti"
					/>
				),
			});
		} else {
			setOpenModalApprovedV2(true);
		}
	};

	const handleContractPlan = async (plan: any, includeFireInsurance: boolean) => {
		setOpenModalApprovedV2(false);
		navigate(`/analises/contratacao?analise=${id}&plano=${plan.planId || plan.id}&fire=${includeFireInsurance}`);
	};

	const handleSaveBudget = async (plan: any, includeFireInsurance: boolean) => {
		try {
			const payload = {
				fee: plan.fee || rows?.fee || "0",
				lessorName: rows?.lessorName || "",
				termBegin: rows?.termBegin ? moment(rows.termBegin).format("YYYY-MM-DD") : "",
				lessorCpf: rows?.lessorCpf || "",
				assuranceMonthAmount: rows?.assuranceMonthAmount?.toString() || "0",
				lmi: plan.lmi?.toString() || "0",
				lmiAmount: plan.lmiAmount?.toString() || "0",
				rentMonthsCount: rows?.rentMonthsCount?.toString() || "0",
				planId: plan.planId || plan.id,
				lessorTypePerson: rows?.lessorTypePerson || "F",
				lessorEmail: rows?.lessorEmail || "",
				lessorPhone: rows?.lessorPhone || "",
				// status: rows?.status, // Keep current status
				obs: includeFireInsurance
					? rows?.obs
						? rows.obs + " | Orçamento Salvo com Seguro Incêndio"
						: "Orçamento Salvo com Seguro Incêndio"
					: rows?.obs,
			};

			await analysisService.updateById(id!, payload as any);

			toastHandler.present({
				type: "success",
				messageOrContent: <ToastContent title="Sucesso" content="Orçamento salvo com sucesso!" />,
			});
			setOpenModalApprovedV2(false);
			getDetailsAnalysis();
		} catch (error) {
			console.error(error);
			toastHandler.present({
				type: "error",
				messageOrContent: <ToastContent title="Erro" content="Erro ao salvar orçamento." />,
			});
		}
	};

	const handleResendInstallment = (id: string, email: string) => {
		FinancialService.sendMailSetup(id, { email }).then((result) => {
			if (result instanceof Error) {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title={"Erro"} content={"Erro ao enviar email"} />,
				});
			} else {
				toastHandler.present({
					type: "success",
					position: "top-right",
					messageOrContent: <ToastContent title={"Sucesso"} content={"Email enviado com sucesso !!!"} />,
				});
			}
		});
	};

	const handleOpenSetupFeeModal = () => {
		if (!canGenerateSetupFee) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Permissão negada" content="Você não possui permissão para gerar taxa de setup." />,
			});
			return;
		}

		if (!isAnalysisStatusOkForSetupFee) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: (
					<ToastContent
						title="Ação indisponível"
						content="A taxa de setup só pode ser gerada quando a análise estiver em Aprovado ou Biometria."
					/>
				),
			});
			return;
		}

		if (!rows?.client?.id) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Erro" content="Cliente não encontrado na análise." />,
			});
			return;
		}

		if (!isSetupFeeEnabledForClient) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Atenção" content="Taxa de setup não habilitada para este cliente." />,
			});
			return;
		}

		if (!isSetupFeeConfigValid) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Atenção" content="Configuração de limites da taxa de setup inválida para este cliente. Verifique min/max." />,
			});
			return;
		}

		setOpenModalSetupFee(true);
	};

	const handleConfirmSetupFee = async (amount: number) => {
		setIsLoadingSetupFee(true);
		try {
			const analysisId = rows?.id || id;
			const toApiAmount = (value: number) => {
				const fixed = Number(value).toFixed(2);
				return fixed.replace(/\.?0+$/, "");
			};

			const payload: IGenerateTaxSetup = {
				analysisId: String(analysisId),
				setup_amount: toApiAmount(amount),
			};

			const result = await analysisService.generateTaxSetup(payload);
			if (result instanceof Error) throw result;

			const tryExtractLink = (payload: any): string | undefined => {
				if (!payload) return undefined;
				if (typeof payload === "string") return payload;
				if (Array.isArray(payload)) {
					const first = payload[0];
					if (typeof first === "string") return first;
					if (first && typeof first === "object") return first.url || first.link || first.urlShort || first.url_short;
				}
				if (typeof payload === "object") return payload.url || payload.link || payload.urlShort || payload.url_short;
				return undefined;
			};

			const link = tryExtractLink(result);
			setOpenModalSetupFee(false);
			if (id && id !== "novo") getDetailsAnalysis();
			if (link) window.open(link, "_blank", "noopener,noreferrer");
			toastHandler.present({
				type: "success",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Sucesso" content="Taxa de setup gerada com sucesso. Link enviado para o e-mail do cliente." />,
			});
		} catch (error) {
			const defaultErrorMessage = "Não foi possível gerar taxa de setup. Tente novamente mais tarde.";
			const rawMessage = String((error as any)?.message ?? "").trim();
			const shouldHideTechnicalMessage =
				!rawMessage ||
				/^network error$/i.test(rawMessage) ||
				/request failed with status code\s*\d+/i.test(rawMessage) ||
				/^request\s*\d+$/i.test(rawMessage);
			const errorMessage = shouldHideTechnicalMessage ? defaultErrorMessage : rawMessage;
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Erro" content={errorMessage || defaultErrorMessage} />,
			});
		} finally {
			setIsLoadingSetupFee(false);
		}

	};

	const handleOpenModalLogs = () => {
		if (!canViewLogAnalysis) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Permissão negada" content="Você não possui permissão para visualizar o log da análise." />,
			});
			return;
		}
		setOpenModalLogs(true);
	};

	const handleCloseModalLogs = () => {
		setOpenModalLogs(false);
	};

	const handleOpenModal = () => {
		setOpenModal(true);
	};

	const handleOpenModalUpdate = () => {
		setOpenModalUpdateContact(true);
		//console.log(prevEmail, prevPhone);
	};

	const handleOpenModalCancel = () => {
		setOpenModalCancel(true);
	};

	const handleReSendEmail = () => {
		setReSendEmail(true);
	};

	const handleReAnalysis = (id: string) => {
		if (permissionLevel) {
			navigate(`/analises/pedido/${id}`);
		}
	};

	const handleSave = (dados: ISendEmail) => {
		dados.email = email;
		dados.id = id;

		// if (!isEmail(email) || prevEmail?.toLocaleLowerCase() !== email?.toLocaleLowerCase()) {
		// 	toastHandler.present({
		// 		type: "error",
		// 		position: "top-right",
		// 		messageOrContent: "Erro ao reenviar email, pois está inválido. Verifique email cadastrado!",
		// 	});
		// 	return;
		// }

		formValidationSchema
			.validate(dados, { abortEarly: false })
			.then((dadosvalidados) => {
				setIsLoading(true);
				analysisService
					.updateEmail({ ...dadosvalidados })
					.then((result) => {
						setIsLoading(false);

						if (result instanceof Error) {
							const titleMessage = "Alerta!!";
							const contentMessage = "Erro: " + result?.message;

							toastHandler.present({
								type: "error",
								position: "top-right",
								messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
							});
						} else {
							handleOpenModal();
						}
					})
					.catch((err: any) => {
						setIsLoading(false);
						const { titleMessage, contentMessage } = returnMessageError(err);

						toastHandler.present({
							type: "error",
							position: "top-right",
							messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
						});
					});
			})
			.catch((errors: yup.ValidationError) => {
				const validationErros: IVFormErros = {};
				errors.inner.forEach((error) => {
					if (!error.path) return;
					validationErros[error.path] = error.message;
				});
				formRef.current?.setErrors(validationErros);
			});
	};

	const handleCancelAnalysis = (dados: ICancelAnalysis) => {
		setIsLoading(true);
		analysisService.updateCanceledId(id, { ...dados }).then((result) => {
			setIsLoading(false);
			if (result instanceof Error) {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title={"Erro"} content={"Erro ao cancelar análise | " + result.message} />,
				});
			} else {
				toastHandler.present({
					type: "success",
					position: "top-right",
					messageOrContent: <ToastContent title={"Sucesso"} content={"Análise cancelada com sucesso"} />,
				});
				navigate("/analises/");
			}
		});
	};

	const handleGenerateProposal = (id: string) => {
		analysisService.generateProposal(id).then((result) => {
			setIsLoading(false);

			if (result instanceof Error) {
				alert(result.message);
			} else {
				// alert('erro');
			}
		});
		setOpenModalGenerateProposal(false);
	};

	const handleOpenModalSerasaResponse = () => {
		if (!canViewCreditDetails) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Permissão negada" content="Você não possui permissão para visualizar os detalhes do crédito." />,
			});
			return;
		}
		setOpenModalDetailSerasaResponse(true);
	};

	const handleModalRevert = async () => {
		const blacklistCount = await handleCheckBlacklist();
		if (blacklistCount === 0) {
			setOpenModalRevert(true);
		} else {
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: "Não é possível reverter análise, Locatário bloqueado",
			});
		}
	};

	const handleCheckBlacklist = async () => {
		try {
			const result = await PeopleService.getAll(1, 10, doc, "active");
			if (result instanceof Error) {
				alert(result.message);
				return 1; // Assume blocked on error to be safe
			} else {
				const count = result.totalCount ?? 0;
				setIsBlacklist(count);
				return count;
			}
		} catch (error) {
			console.error(error);
			return 1;
		}
	};

	const getDetailsAnalysis = () => {
		setRows(undefined);
		setBiometryRows(undefined);
		setIsLoading(true);
		analysisService.getDetails(`${id}`).then(async (result) => {
			const analysisRow = result as IDetalheAnalises;
			const biometryRowResult = await analysisService.getBiometryDetails(analysisRow.id as string);

			setIsLoading(false);
			if (result instanceof Error) {
				alert(result.message);
				navigate("/analises");
			} else {
				setBiometryRows(biometryRowResult as BiometryDetails);
				setNome(result.name);
				setProFinally(result.propertyFinally);
				setDoc(result.document);
				setDocLessor(result.lessorCpf);
				setStatus(result.status);
				setRows((prev) => {
					const nextAny = result as any;
					const prevAny = prev as any;
					const nextReasonId = nextAny?.reasonId ?? nextAny?.reason_id;
					const prevReasonId = prevAny?.reasonId ?? prevAny?.reason_id;
					return {
						...(nextAny ?? {}),
						reasonId: nextReasonId ?? prevReasonId,
					} as IDetalheAnalises;
				});
				setCreatedFrom(result.createdFrom);
				setPrevEmail(result.email);
				setPrevPhone(maskPhone(result.phone));

				formRefEdit?.current?.setData({
					id: result.id,
					status: result.status,
					obs: result.obs,
					createdFrom: result.createdFrom,
					assuranceMonthAmount: String(result.assuranceMonthAmount),
					rentAmount: String(result.rentAmount),
					lmi: String(result.lmi),
					residentialFee: formatScaleValue(String(result.residentialFee)),
					commercialFee: formatScaleValue(String(result.commercialFee)),
					fee: formatScaleValue(String(result.fee)),
					planlist: JSON.stringify(result.planlist, null, 1),
					updatedAt: result.updated_at,
				});

				setPrevEmail(result.email);
				let baseAssurance = parseFloat(result.rentAmount);

				setChargesBaseCalc(parseFloat(result.rentAmount) + parseFloat(result.condominiumAmount) + parseFloat(result.iptuAmount));

				setAssuranceBaseCalc(baseAssurance);
				setRentAmount(parseFloat(result?.rentAmount));
				//alert(rentAmount);
				if (result?.userId) {
					userService.getByID(`${result.userId}`).then((resultUser) => {
						setIsLoading(false);
						if (resultUser instanceof Error) {
							//alert(result.message);
							//navigate('/analises');
						} else {
							setUser(resultUser);
						}
					});
				}
				analysisService.rulesMaxProposal(result.document, result.propertyFinally).then((rules) => {
					setRulesMaxProposal({
						rules: rules?.rules,
						message: rules?.message,
					});
				});

				try {
					const planos = JSON.parse(result.planlist); //regra buscar planos somente que a flag Analysis==1
					const plansAnalysisSelect = planos.filter((rowPlan: IPlan) => rowPlan.flagAnalysis == undefined || rowPlan?.flagAnalysis == "1");
					setPlan(plansAnalysisSelect);
					console.log("537.....", plansAnalysisSelect);
				} catch (_) {
					console.log("Erro ao realizar parse do objeto de planos");
				}
			}
		});
	};

	const handleModalEditSuperClose = () => {
		setOpenModalEditSuper(false);
	};

	const handleOpenConvertToPj = () => {
		if (!showConvertToPjAction) return;
		setConvertToPjFrom({
			name: String(rows?.name ?? ""),
			document: String(rows?.document ?? ""),
		});
		setOpenModalConvertToPj(true);
	};

	const handleConfirmConvertToPj = async (data: { document: string; name: string }) => {
		try {
			setIsLoadingConvertToPj(true);
			const result = await analysisService.convertAnalysisToPj(String(id), {
				name: data.name,
				document: data.document,
				typePerson: "legal",
				motherName: `${convertToPjFrom.name} - ${convertToPjFrom.document}`,
			});
			setIsLoadingConvertToPj(false);
			setOpenModalConvertToPj(false);

			if (result instanceof Error) {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title="Erro ao converter análise" content="Erro ao converter análise." />,
				});
				return;
			}

			toastHandler.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title={result.message as string} content={result.description as string} />,
			});
			getDetailsAnalysis();
		} catch (err: any) {
			setIsLoadingConvertToPj(false);
			// Mantém mensagem padronizada para esta ação (evita mensagens genéricas do handler)
			void returnMessageError(err);
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro ao converter análise" content="Erro ao converter análise." />,
			});
		}
	};

	const openModalEdit = () => {
		setOpenModalEditSuper(true);
		getDetailsAnalysis();
		handleCheckBlacklist();
	};

	const handleSaveEdit = (dados: IUpdateAnalysisSuperAdmin) => {
		dados.updatedAt = moment.tz("America/Sao_Paulo").toDate();
		dados.assuranceMonthAmount = dados.assuranceMonthAmount ? removeMask(dados.assuranceMonthAmount) : dados.assuranceMonthAmount;
		dados.rentAmount = dados.rentAmount ? removeMask(dados.rentAmount) : dados.rentAmount;
		dados.residentialFee = dados.residentialFee ? removeMask(dados.residentialFee) : dados.residentialFee;
		dados.commercialFee = dados.commercialFee ? removeMask(dados.commercialFee) : dados.commercialFee;
		dados.fee = dados.fee ? removeMask(dados.fee) : dados.fee;
		dados.obs = !dados.obs ? "" : dados.obs;
		dados.obs = !dados.obs ? "" : dados.obs;
		// dados.planlist = JSON.parse(dados.planlist);

		formEditValidationSchema
			.validate(dados, { abortEarly: false })
			.then((dadosValidados) => {
				setIsLoadingEditSuper(true);
				analysisService
					.updateAnalysisSuperAdmin(dadosValidados)
					.then((result: IMessage<null> | Error) => {
						setIsLoadingEditSuper(false);
						if (result instanceof Error) {
							const titleMessage = "Alerta!!";
							const contentMessage = "Erro: " + result?.message;

							toastHandler.present({
								type: "error",
								position: "top-right",
								messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
							});
						} else {
							handleModalEditSuperClose();
							getDetailsAnalysis();

							const { message, description } = result;

							toastHandler.present({
								type: "success",
								position: "top-right",
								messageOrContent: <ToastContent title={message as string} content={description as string} />,
							});
						}
					})
					.catch((err: any) => {
						setIsLoadingEditSuper(false);
						const { titleMessage, contentMessage } = returnMessageError(err);

						toastHandler.present({
							type: "error",
							position: "top-right",
							messageOrContent: <ToastContent title={titleMessage} content={contentMessage} />,
						});
					});
			})
			.catch((errors: yup.ValidationError) => {
				setIsLoadingEditSuper(false);
				const validationErros: IVFormErros = {};
				errors?.inner?.forEach((error) => {
					if (!error.path) return;
					validationErros[error.path] = error.message;
				});
				formRefEdit?.current?.setErrors(validationErros);
			});
	};

	const handleOpenBiometry = () => {
		if (!canViewBiometry) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Permissão negada" content="Você não possui permissão para visualizar a biometria." />,
			});
			return;
		}
		setShowBiometry(true);
	};

	const handleResendCurrentAnalysis = () => {
		if (!canResendAnalysis) {
			toastHandler.present({
				type: "error",
				position: "top-right",
				durationMs: 4000,
				messageOrContent: <ToastContent title="Permissão negada" content="Você não possui permissão para reenviar a análise." />,
			});
			return;
		}
		if (!id || id === "novo") return;

		analysisService.resendAnalysis(id, "4").then((result) => {
			if (result instanceof Error) {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title={"Alerta!"} content={"Erro: " + result?.message} />,
				});
			} else {
				toastHandler.present({
					type: "success",
					position: "top-right",
					messageOrContent: <ToastContent title={"Sucesso!"} content={"Análise reenviada com sucesso!"} />,
				});
			}
		});
	};

	const ColorTytle = "#1c1b1b";

	useEffect(() => {
		if (id !== "novo") {
			getDetailsAnalysis();
		}
	}, [id]);

	useEffect(() => {
		if (rows?.status && (rows.status === "refused" || rows.status === "canceled" || rows.status === "expired")) {
			setShowButtonRevert(true);
		} else {
			setShowButtonRevert(false);
		}
	}, [rows]);

	const canRevertAnalysis = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.RevertAnalysis);

	return (
		<LayoutBaseDePagina
			titulo="Análises"
			subtitulo={id === "novo" ? "Nova análise de crédito" : `Alteração de análise [ ${nome} ]`}
			barraDeFerramentas={
				<ToolbarAnalysis
					clickAnalysis={handleOpenModalResultAnalysis}
					showButtonAnalysis={
						createdFrom != "web_service" &&
						status === "issued" &&
						(isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.Conclude))
					}
					showButtonProposal={
						status === "awaiting_signature" &&
						(isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.WarrantiesOptions, PermissionActionsEnum.Add))
					}
					showButtonEmailresend={
						canResendAnalysisEmail ? true : false
					}
					showButtonCancel={
						(isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.Conclude)) &&
						(status === "issued" || status == "awaiting_signature" || status === "awaiting_biometria")
							? createdFrom == "web_service"
								? false
								: true
							: false
					}
					showButtonReAnalysis={
						(isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.Conclude)) &&
						status != "canceled" &&
						status != "hired" &&
						status != "awaiting_signature"
							? createdFrom == "web_service"
								? false
								: true
							: false
					}
					clickCancel={() => handleOpenModalCancel()}
					clickBack={() => navigate("/analises")}
					clickProposal={() => setOpenModalGenerateProposal(true)}
					showButtonSetupFee={false}
					showButtonSetupFeeLoading={isLoadingSetupFee}
					clickSetupFee={handleOpenSetupFeeModal}
					clickEmailResend={() => setReSendEmail(true)}
					clickReAnalysis={() => SetModalReAnalisys(true)}
					textButtonAnalysis={"Contratar Seguro"}
					showButtonUpdateContact={
						(isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.AnalysisOptions, PermissionActionsEnum.Biometria)) && status === "awaiting_biometria"
							? true
							: false
					}
					clickUpdateContact={() => handleOpenModalUpdate()}
				/>
			}
		>
			<LoadingComp isopen={isLoading || isLoadingEditSuper || isLoadingSetupFee} />
			<Grid container gap={1} sx={{ width: "100%", maxWidth: "1300px", ml: 1 }}>
				{rows && (
					<AnalysisCardData
						row={rows}
						user={user}
						biometry={biometryRows}
						planList={plan}
						onclickbuttonResend={handleResendInstallment}
						onUpdateStatus={openModalEdit}
						onRevertAnalysis={handleModalRevert}
						showRevertAnalysis={showButtonRevert && canRevertAnalysis}
						disableRevertAnalysis={isBlacklist > 0}
						onResendAnalysis={handleResendCurrentAnalysis}
						showResendAnalysis={canResendAnalysis && status != "issued"}
						onViewBiometry={handleOpenBiometry}
						showViewBiometry={canViewBiometry}
						onViewCreditDetails={handleOpenModalSerasaResponse}
						showViewCreditDetails={canViewCreditDetails}
						onGenerateSetupFee={handleOpenSetupFeeModal}
						showGenerateSetupFee={showGenerateSetupFeeAction}
						onConvertToPj={handleOpenConvertToPj}
						showConvertToPj={showConvertToPjAction}
					/>
				)}
			</Grid>

			<ModalConvertAnalysisToPj
				isOpen={openModalConvertToPj}
				onClose={() => {
					if (isLoadingConvertToPj) return;
					setOpenModalConvertToPj(false);
				}}
				initialDocument={rows?.document}
				initialName={rows?.name}
				isLoading={isLoadingConvertToPj}
				onConfirm={handleConfirmConvertToPj}
			/>
			<ModalResendBiometryLink
				isOpen={openModalUpdateContact}
				onClose={() => setOpenModalUpdateContact(false)}
				analysisId={id}
				initialEmail={rows?.email ?? prevEmail}
				initialPhone={String(rows?.phone ?? prevPhone ?? "").replace(/\D/g, "")}
			/>

			<ModalSetupFee
				isOpen={openModalSetupFee}
				onClose={() => setOpenModalSetupFee(false)}
				minValue={setupFeeLimitMin}
				maxValue={setupFeeLimitMax}
				defaultValue={String(rows?.client?.tax_setup_limit_default ?? setupFeeLimitMin ?? "0")}
				isLoading={isLoadingSetupFee}
				onConfirm={handleConfirmSetupFee}
			/>

			{loggedUser?.role == "admin" && isSuperAdmin && (
				<AnalysisEditModal
					open={openModalEditSuper}
					onClose={handleModalEditSuperClose}
					onSubmit={handleSaveEdit}
					initialData={rows}
					isLoading={isLoadingEditSuper}
					isBlacklist={isBlacklist}
				/>
			)}

			{openModal && (
				<BasicModal
					isCloseModal={() => setOpenModal(false)}
					isOpenModal={openModal}
					messageType={"success"}
					showButtonCancel={false}
					textButtonConfirm={"OK"}
					onclickConfirm={() => {
						setOpenModal(false);
						navigate("/analises");
					}}
					IMessage={"Contratação realizada com sucesso !"}
				/>
			)}

			{openModalResultAnalysis && status === "pre_approved" && (
				<ModalContext
					isCloseModal={() => setOpenModalResultAnalysis(false)}
					isOpenModal={openModalResultAnalysis}
					messageType={"pre_success"}
					showButtonCancel={false}
					overrideWidthValue="33%"
					textButtonConfirm={"Cancelar"}
					ITitle={"Análise Pré-Aprovada "}
					IMessage={[
						<Box>
							<Grid
								item
								sx={{
									width: "100%",
									padding: "0.2% 2.3%",
									borderRadius: "4px",
								}}
							>
								<Box display={"flex"} gap={1} alignItems={"center"}>
									<Typography variant="body1" sx={{ color: "#2b94e2" }}>
										Analise Pré-Aprovada com valor de até
									</Typography>
									<Typography
										variant="body1"
										sx={{
											color: "#2b94e2",
											fontWeight: "600",
											fontSize: "18px",
										}}
									>
										{parseFloat(`${rows?.creditLimit}`).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
									</Typography>
								</Box>
								<Typography variant="subtitle2" sx={{ color: "#2b94e2" }}>
									Próximos passos: você deverá reduzir o valor do aluguel e taxas e ou negociar junto ao proprietário ou ainda buscar outro
									imóvel que possua os valores e taxas compatíveis com este valor total pré-aprovado.
								</Typography>
							</Grid>
							<Grid
								container
								item
								sm={12}
								sx={{
									border: "none",
									display: "flex",
									justifyContent: "center",
									mt: 2,
								}}
								display={"flex"}
								flexDirection={smDown ? "column" : "row"}
								padding={2}
								gap={2}
							>
								<Button
									color="primary"
									disableElevation
									variant={"contained"}
									startIcon={<Icon> checkIcon</Icon>}
									onClick={() => {
										handleReAnalysis(id);
										setOpenModalResultAnalysis(false);
									}}
								>
									{"Contratar"}
								</Button>
								<Button
									color="primary"
									disableElevation
									variant={"outlined"}
									startIcon={<Icon> arrow_back_Ico</Icon>}
									onClick={() => {
										setOpenModalResultAnalysis(false);
									}}
								>
									{"Voltar"}
								</Button>
							</Grid>
						</Box>,
					]}
				/>
			)}

			{openModalCancel && (
				<ModalContext
					isCloseModal={() => setOpenModalCancel(false)}
					isOpenModal={openModalCancel}
					messageType={"alert"}
					showButtonCancel={false}
					textButtonConfirm={"Cancelar"}
					onclickConfirm={() => {
						handleOpenModalCancel();
					}}
					ITitle={"Deseja cancelar a análise de crédito ?"}
					IMessage={[
						<Box style={{ width: "100%" }}>
							<Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, color: "#7d7d7d" }}>
								<VForm
									id="formIdCancel"
									placeholder="Your placeholder"
									onPointerEnterCapture={() => console.log("Pointer entered")}
									onPointerLeaveCapture={() => console.log("Pointer left")}
									ref={formRef}
									onSubmit={handleCancelAnalysis}
								>
									<Grid container item direction="column" padding={1} spacing={2}>
										{isLoading && (
											<Grid item>
												<LinearProgress variant="indeterminate" />
											</Grid>
										)}
										<Grid container item direction="row" spacing={2}>
											<Grid item xs={12}>
												<VTextField
													fullWidth
													label="Motivo do cancelamento"
													name="canceledType"
													disabled={isLoading}
													defaultValue="Outros"
													select
												>
													{cancelReasons.map((reason, index) => (
														<MenuItem key={index} value={reason.value}>
															{reason.label}
														</MenuItem>
													))}
												</VTextField>
											</Grid>
											<Grid item xs={12}>
												<VTextField
													fullWidth
													label="Descreva o motivo"
													name="canceledReason"
													disabled={isLoading}
													multiline
													rows={4}
												></VTextField>
											</Grid>
										</Grid>
									</Grid>

									<Grid
										container
										item
										sm={12}
										sx={{
											border: "none",
											display: "flex",
											justifyContent: "center",
										}}
										display={"flex"}
										flexDirection={smDown ? "column" : "row"}
										padding={2}
										gap={2}
									>
										<Button
											color="primary"
											disableElevation
											variant={"contained"}
											startIcon={<Icon> check</Icon>}
											onClick={() => {
												formRef.current?.submitForm();
												// navigate("/analises/"); // Removed navigate here, it's handled in handleCancelAnalysis
											}}
										>
											{"Cancelar análise"}
										</Button>
										<Button
											color="primary"
											disableElevation
											variant={"outlined"}
											startIcon={<Icon> arrow_back_Ico</Icon>}
											onClick={() => {
												setOpenModalCancel(false);
											}}
										>
											{"Voltar"}
										</Button>
									</Grid>
								</VForm>
							</Typography>
						</Box>,
					]}
				/>
			)}

			{modalReAnalysis && (
				<ModalContext
					isCloseModal={() => setOpenModalResultAnalysis(false)}
					isOpenModal={modalReAnalysis}
					messageType={"question"}
					showButtonCancel={false}
					overrideWidthValue="36%"
					textButtonConfirm={"Cancelar"}
					ITitle={"Deseja fazer a Reanálise  ?"}
					IMessage={[
						<Grid
							container
							item
							sm={12}
							sx={{ border: "none", display: "flex", justifyContent: "center" }}
							display={"flex"}
							flexDirection={smDown ? "column" : "row"}
							padding={2}
							gap={2}
						>
							<Button
								color="primary"
								disableElevation
								variant={"contained"}
								startIcon={<Icon> checkIcon</Icon>}
								onClick={() => {
									handleReAnalysis(id);
									SetModalReAnalisys(false);
								}}
							>
								{"Reanalisar"}
							</Button>
							<Button
								color="primary"
								disableElevation
								variant={"outlined"}
								startIcon={<Icon> arrow_back_Ico</Icon>}
								onClick={() => {
									SetModalReAnalisys(false);
								}}
							>
								{"Voltar"}
							</Button>
						</Grid>,
					]}
				/>
			)}

			{openModalGenerateProposal && (
				<ModalContext
					isCloseModal={() => setOpenModalGenerateProposal(false)}
					isOpenModal={openModalGenerateProposal}
					messageType={"alert"}
					showButtonCancel={false}
					textButtonConfirm={"Cancelar"}
					onclickConfirm={() => {
						handleGenerateProposal(id);
					}}
					ITitle={"Criação de garantia "}
					IMessage={[
						<Box style={{ width: "100%" }}>
							<Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, color: "#7d7d7d", textAlign: "center" }}>
								Confirma a criação de uma garantia sem Assinatura de contrato ?
							</Typography>
							{/* <Typography>
                            {`${id}`}
                          </Typography> */}
							<Grid
								container
								item
								sm={12}
								sx={{
									border: "none",
									display: "flex",
									justifyContent: "center",
								}}
								display={"flex"}
								flexDirection={smDown ? "column" : "row"}
								padding={2}
								gap={2}
							>
								<Button
									color="info"
									disableElevation
									variant={"contained"}
									startIcon={<Icon> checkIcon</Icon>}
									onClick={() => {
										handleGenerateProposal(id);
										navigate("/garantias/");
									}}
								>
									{"Gerar Garantia"}
								</Button>
								<Button
									color="info"
									disableElevation
									variant={"outlined"}
									startIcon={<Icon> arrow_back_Ico</Icon>}
									onClick={() => {
										setOpenModalGenerateProposal(false);
									}}
								>
									{"Voltar"}
								</Button>
							</Grid>
						</Box>,
					]}
				/>
			)}

			{reSendEmail && (
				<ModalContext
					isCloseModal={() => setReSendEmail(false)}
					isOpenModal={reSendEmail}
					messageType={"alert"}
					showButtonCancel={false}
					textButtonConfirm={"Cancelar"}
					onclickConfirm={() => {}}
					ITitle={"Confirmação de email"}
					IMessage={[
						<Box style={{ width: "100%" }}>
							<Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, color: "#7d7d7d" }}>
								<VForm
									id="formIdSave"
									placeholder="Your placeholder"
									onPointerEnterCapture={() => console.log("Pointer entered")}
									onPointerLeaveCapture={() => console.log("Pointer left")}
									ref={formRef}
									onSubmit={handleSave}
								>
									<Grid container item direction="column" padding={1} spacing={2}>
										{isLoading && (
											<Grid item>
												<LinearProgress variant="indeterminate" />
											</Grid>
										)}
										<Grid container item direction="row" spacing={1} sx={{ mb: 2 }}>
											<Grid item xs={4} sx={{ textAlign: "right" }}>
												Confirme o email cadastrado :
											</Grid>
											<Grid item xs={6} sx={{ alignItems: "left" }}>
												<Typography variant="inherit" sx={{ fontWeight: "bold" }}>
													{prevEmail}
												</Typography>
											</Grid>
										</Grid>
										<Grid container item direction="row" spacing={2}>
											<Grid item xs={12}>
												<VTextField
													fullWidth
													label="Confirma o email do locatário"
													name="email"
													//placeholder={prevEmail}
													trimEmptySpaces={true}
													disabled={isLoading}
													onChange={(e) => setEmail(e.target.value)}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton aria-label="toggle password visibility" edge="end">
																	<EmailOutlined />
																</IconButton>
															</InputAdornment>
														),
													}}
												/>
											</Grid>
										</Grid>
									</Grid>

									<Grid
										container
										item
										sm={12}
										sx={{
											border: "none",
											display: "flex",
											justifyContent: "center",
										}}
										display={"flex"}
										flexDirection={smDown ? "column" : "row"}
										padding={2}
										gap={2}
									>
										<Button
											color="info"
											disableElevation
											variant={"contained"}
											startIcon={<Icon> checkIcon</Icon>}
											onClick={() => {
												formRef.current?.submitForm();
											}}
										>
											{"Confirmar"}
										</Button>
										<Button
											color="info"
											disableElevation
											variant={"outlined"}
											startIcon={<Icon> arrow_back_Ico</Icon>}
											onClick={() => {
												setReSendEmail(false);
											}}
										>
											{"Voltar"}
										</Button>
									</Grid>
								</VForm>
							</Typography>
						</Box>,
					]}
				/>
			)}

			{openModalSerasaResponse && rows && (
				<ModalContext
					isCloseModal={() => setOpenModalSerasaResponse(false)}
					isOpenModal={openModalSerasaResponse}
					messageType={"question"}
					showButtonCancel={false}
					showButtonConfirm={false}
					showTitleIcon={false}
					textButtonCancel="Fechar"
					onclickConfirm={() => {}}
					enableBackdropClose={true}
					overrideWidthValue={"60%"}
					ITitle={"Resposta do Serasa"}
					IMessage={[<SerasaResponseRejectedModalContent analysis={rows} />]}
				/>
			)}

			{/* Logs da Análise e Serasa  */}
			{canShowLogsSection && (
				<Grid container sx={{ width: "100%", maxWidth: "1300px", mt: 1, ml: 1 }}>
					<Grid item xs={12}>
						<Card variant="outlined" sx={{ borderRadius: 2 }}>
							<CardContent sx={{ p: 2 }}>
								<Typography variant="h6" color={ColorTytle}>
									Logs
								</Typography>
								<Grid container spacing={2}>
									<Grid item xs={12}>
										<Box
											display="flex"
											alignItems="center"
											justifyContent="space-between"
											flexWrap="wrap"
											gap={2}
											sx={{
												boxShadow: "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
												borderRadius: 2,
												p: 2,
											}}
										>
											<Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
												<Typography variant="h6" sx={{ fontWeight: 400 }}>
													Logs da Análise
												</Typography>
												<Tooltip
													title={
														!isPermissionInitialized
															? "Carregando permissões..."
															: canViewLogAnalysis
																? ""
																: "Sem permissão para visualizar o log da análise"
													}
												>
													<span>
														<Button
															color="primary"
															disableElevation
															variant="outlined"
															startIcon={<RemoveRedEyeOutlinedIcon />}
															onClick={handleOpenModalLogs}
															disabled={!canViewLogAnalysis}
														>
															Visualizar
														</Button>
													</span>
												</Tooltip>
											</Box>

											{((rows as any)?.reasonId || (rows as any)?.reason_id) && (
												<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
													<Icon sx={{ color: "#c12c00" }}>report_problem_outlined</Icon>
													<Typography variant="subtitle1" sx={{ fontWeight: 400, color: "#c12c00" }}>
														Motivo recusa: {(rows as any)?.reasonId ?? (rows as any)?.reason_id}
													</Typography>
												</Box>
											)}
										</Box>
									</Grid>

									<Grid item xs={12}>
										<Box
											display="flex"
											alignItems="center"
											justifyContent="space-between"
											flexWrap="wrap"
											gap={2}
											sx={{
												boxShadow: "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
												borderRadius: 2,
												p: 2,
											}}
										>
											<Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
												<Typography variant="h6" sx={{ fontWeight: 400 }}>
													Logs Serasa
												</Typography>
												<Tooltip
													title={
														!isPermissionInitialized
															? "Carregando permissões..."
															: canViewLogSerasa
																? ""
																: "Sem permissão para visualizar o log do Serasa"
													}
												>
													<span>
														<Button
															color="primary"
															disableElevation
															variant="outlined"
															startIcon={<RemoveRedEyeOutlinedIcon />}
															onClick={handleOpenModalLogsSerasa}
															disabled={!canViewLogSerasa}
														>
															Visualizar
														</Button>
													</span>
												</Tooltip>
											</Box>

										{rows?.sendSerasa == "send_serasa" ? (
											<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
												<Icon sx={{ color: "#55c355" }}>send_outlined_icon</Icon>
												<Typography
													variant="subtitle1"
													sx={{
														fontWeight: 400,
														color: "#55c355",
														alignContent: "center",
													}}
												>
													Análise enviada para o Serasa
												</Typography>
											</Box>
										) : (
											<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
												<Icon sx={{ color: "#c12c00" }}>cancel_schedule_send_outlined_icon</Icon>
												<Typography variant="subtitle1" sx={{ fontWeight: 400, color: "#c12c00" }}>
													Análise não enviada para o Serasa
												</Typography>
											</Box>
										)}
									</Box>
									{/* Detalhes do Crédito e Reverter Análise foram movidos para o menu ao lado da análise */}
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			)}

			{/* Modal Visualização do log do Serasa */}
			{canViewLogSerasa && (
				<ModalLogSerasaAnalysis
					isOpen={openModalLogsSerasa}
					onClose={handleCloseModalLogsSerasa}
					analysisId={id}
					reasonId={(rows as any)?.reasonId ?? (rows as any)?.reason_id ?? null}
				/>
			)}

			{/* Modal de logs da análise (extraído do AnalysisDetailPresentation) */}
			{canViewLogAnalysis && <ModalLogsAnalysis isOpen={openModalLogs} onClose={handleCloseModalLogs} id={id} />}

			{canViewCreditDetails && openModalDetailSerasaResponse && (
				<ModalDetailSerasaResponse data={rows} isClose={() => setOpenModalDetailSerasaResponse(false)} isOpenModal={openModalDetailSerasaResponse} />
			)}

			{/* Payload agora é exibido dentro da ModalLogsAnalysis */}

			{showButtonRevert && canRevertAnalysis && (
				<RevertModal
					isOpen={openModalRevert}
					onClose={(options) => {
						setOpenModalRevert(false);
						if (options?.shouldRefresh) getDetailsAnalysis();
					}}
					row={rows}
				/>
			)}

			{showBiometry && (
				<ModalDetailBiometrics
					isOpen={showBiometry}
					onClose={() => {
						setShowBiometry(false);
						//getDetailsAnalysis();
					}}
					biometricsId={id}
				/>
			)}

			{openModalApprovedV2 && rows && (
				<>
					{/* {console.log("Rows when opening ModalApprovedV2:", rows)} */}
					<ModalApprovedV2
						open={openModalApprovedV2}
						onClose={() => setOpenModalApprovedV2(false)}
						onSuccess={handleContractPlan}
						onSave={handleSaveBudget}
						plans={parsedPlans}
						rentAmount={parseFloat(rows?.rentAmount || "0")}
						chargesAmount={parseFloat(rows?.condominiumAmount || "0") + parseFloat(rows?.iptuAmount || "0")}
						estateId={rows.estateId || (rows as any).estate_id || (rows as any).imobiliaria_id || (rows.estate as any)?.id}
						clientId={rows.client?.id}
						zipCode={rows.addressZipcode}
						propertyType={rows.propertyType}
					/>
				</>
			)}
		</LayoutBaseDePagina>
	);
};
